import { Component } from '@angular/core';
import { AlertController } from 'src/app/shared/components/alert/services/alert-controller.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  constructor(public alertController: AlertController) {}
}

export interface AlertInfo {
  title?: string;
  msg?: string;
  msgList?: CustomMessage;
  showIcon?: boolean;
  iconName?: string;
  iconColor?: string;
  loadingColor?: string;
  buttons?: ButtonAlert[];
}

export interface ButtonAlert {
  buttonText: string;
  buttonTextColor?: 'light' | 'dark';
  buttonHandler: any;
  buttonColor: string;
  buttonIcon?: string;
}

export interface CustomMessage {
  msg: string;
  icon: string;
  iconSlot: string;
}
